import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.formCategory.fields.id'),
  },
  {
    name: 'icon',
    label: i18n('entities.formCategory.fields.icon'),
    render: exporterRenders.filesOrImages(),
  },
  {
    name: 'name',
    label: i18n('entities.formCategory.fields.name'),
  },
  {
    name: 'abbreviation',
    label: i18n('entities.formCategory.fields.abbreviation'),
  },
  {
    name: 'description',
    label: i18n('entities.formCategory.fields.description'),
  },
  {
    name: 'parentCategory',
    label: i18n('entities.formCategory.fields.parentCategory'),
    render: exporterRenders.relationToOne(),
  },
  {
    name: 'tenantAccess',
    label: i18n('entities.formCategory.fields.tenantAccess'),
  },
  {
    name: 'createdAt',
    label: i18n('entities.formCategory.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.formCategory.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
